(() => {
  'use strict';
  if (window.spWishlistReady) return;
  window.spWishlistReady = true;
  const configElement = document.getElementById('sp-wishlist-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const text = config.texts;
  const root = config.root.replace(/\/?$/, '/');
  const storageKey = 'soposters.wishlist.v1';
  const context = `${root}|${config.country}`;
  const page = document.querySelector('[data-sp-wishlist]');
  const grid = page?.querySelector('[data-sp-grid]');
  const status = page?.querySelector('[data-sp-status]');
  const live = document.getElementById('sp-wishlist-live');
  let memory = [];
  let storageFailed = false;
  let busy = false;
  let generation = 0;
  let sharedItems = null;
  const products = new Map();
  const selected = new Map();
  const safeURL = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.hostname === config.storeDomain) {
        url.protocol = location.protocol;
        url.host = location.host;
      }
      return url.origin === location.origin && /\/products\/[^/]+\/?$/.test(url.pathname) ? url : null;
    } catch { return null; }
  };
  if (page && location.hash.startsWith('#wishlist=')) {
    try {
      if (location.hash.length > 50000) throw new Error('Invalid shared list');
      const incoming = JSON.parse(decodeURIComponent(location.hash.slice(10)));
      if (!Array.isArray(incoming) || incoming.length > 100) throw new Error('Invalid shared list');
      const valid = incoming.filter(item => item && /^\d+$/.test(String(item.id)) && safeURL(item.url));
      if (valid.length !== incoming.length) throw new Error('Invalid shared list');
      sharedItems = [...new Map(valid.map(item => [String(item.id), {id:String(item.id),url:safeURL(item.url).pathname}])).values()];
      page.querySelector('[data-sp-shared-note]').hidden = false;
    } catch { page.querySelector('[data-sp-share-status]').textContent = text.share_error; }
  }
  function read() {
    if (sharedItems !== null) return sharedItems;
    if (storageFailed) return memory;
    try {
      const parsed = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(parsed)) return [];
      memory = parsed.filter(item => /^\d+$/.test(String(item.id)) && safeURL(item.url)).slice(0, 100);
    } catch { storageFailed = true; }
    return memory;
  }
  function write(items) {
    if (sharedItems !== null) { sharedItems = items; return; }
    memory = items;
    try { localStorage.setItem(storageKey, JSON.stringify(items)); }
    catch { storageFailed = true; }
  }
  function announce(message) { if (live) live.textContent = message; }
  function sync() {
    document.querySelectorAll('.product__info-container > [data-sp-heart]').forEach(button => {
      const product = button.closest('.product');
      const media = product?.querySelector('.product__media-wrapper');
      const host = media?.querySelector('.pb-preview') || media;
      if (!host || !media.querySelector('img, video, model-viewer')) return;
      host.classList.add('sp-product-heart-host');
      button.classList.add('sp-heart--product');
      host.append(button);
    });
    const saved = read();
    const shareButton = page?.querySelector('[data-sp-share]');
    if (shareButton) shareButton.disabled = saved.length === 0;
    document.querySelectorAll('[data-sp-heart]').forEach(button => {
      const active = saved.some(item => String(item.id) === button.dataset.productId);
      button.hidden = false;
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? text.remove : text.add);
    });
    document.querySelectorAll('[data-sp-count]').forEach(counter => {
      counter.textContent = String(saved.length);
      counter.hidden = saved.length === 0;
    });
  }
  async function shareWishlist() {
    const shareStatus = page.querySelector('[data-sp-share-status]');
    const items = read().map(item => ({id:String(item.id),url:products.get(String(item.id))?.url || item.paths?.[context] || item.url}));
    if (!items.length) return;
    const url = new URL(`${root}search`,location.origin);
    url.searchParams.set('view','wishlist');
    url.hash = `wishlist=${encodeURIComponent(JSON.stringify(items))}`;
    if (url.href.length > 16000) { shareStatus.textContent = text.share_too_long; return; }
    if (typeof navigator.share === 'function') {
      try { await navigator.share({title:text.title,url:url.href}); return; }
      catch (error) { if (error.name === 'AbortError') return; }
    }
    try {
      await navigator.clipboard.writeText(url.href);
      shareStatus.textContent = text.share_copied;
    } catch {
      const fallback = page.querySelector('[data-sp-share-fallback]');
      const input = fallback.querySelector('[data-sp-share-link]');
      input.value = url.href;
      fallback.hidden = false;
      input.focus();
      input.select();
      shareStatus.textContent = text.share_copy;
    }
  }
  function element(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }
  function remove(id) {
    write(read().filter(item => String(item.id) !== String(id)));
    selected.delete(String(id));
    sync();
    if (page) render();
  }
  function rememberPath(id, url) {
    const items = read();
    const item = items.find(value => String(value.id) === String(id));
    if (!item) return;
    item.paths = { ...(item.paths || {}), [context]: url };
    write(items);
  }
  async function load(item, refresh = false) {
    const key = String(item.id);
    if (!refresh && products.has(key)) return products.get(key);
    let url = safeURL(item.paths?.[context] || item.url);
    if (!url) throw new Error(text.unavailable);
    const response = await fetch(url.pathname, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
    if (!response.ok) throw new Error(text.unavailable);
    let doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const productPrefix = `${root}products/`;
    if (!new URL(response.url).pathname.startsWith(productPrefix)) {
      const alternates = [...doc.querySelectorAll('link[rel="alternate"][hreflang]')];
      const alternate = alternates.map(link => safeURL(link.href)).find(link => link?.pathname.startsWith(productPrefix));
      if (!alternate) throw new Error(text.unavailable);
      const localized = await fetch(alternate.pathname, { credentials: 'same-origin', signal: AbortSignal.timeout(20000) });
      if (!localized.ok) throw new Error(text.unavailable);
      doc = new DOMParser().parseFromString(await localized.text(), 'text/html');
    }
    const dataNode = doc.querySelector('[data-sp-wishlist-product]');
    if (!dataNode) throw new Error(text.unavailable);
    const product = JSON.parse(dataNode.textContent);
    if (String(product.id) !== key || !Array.isArray(product.variants)) throw new Error(text.unavailable);
    if (doc.querySelector('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]')) product.custom = true;
    const localizedURL = safeURL(product.url);
    if (!localizedURL || !localizedURL.pathname.startsWith(productPrefix)) throw new Error(text.unavailable);
    product.url = localizedURL.pathname;
    products.set(key, product);
    rememberPath(key, product.url);
    return product;
  }
  function chosen(product) {
    return product.variants.find(variant => String(variant.id) === selected.get(String(product.id)) && variant.available);
  }
  function card(product) {
    const key = String(product.id);
    const node = element('article', 'sp-wishlist-item');
    const imageLink = element('a', 'sp-wishlist-image');
    imageLink.href = product.url;
    if (product.image) {
      const image = element('img');
      const source = new URL(product.image, location.origin);
      if (source.protocol === 'https:') image.src = source.href;
      image.alt = product.alt || product.title;
      image.width = 600;
      image.height = 800;
      image.loading = grid.children.length < 2 ? 'eager' : 'lazy';
      imageLink.append(image);
    }
    node.append(imageLink);
    const removeButton = element('button', 'sp-heart');
    const heartIcon = document.querySelector('.sp-wishlist-link svg')?.cloneNode(true);
    if (heartIcon) removeButton.append(heartIcon);
    else removeButton.textContent = '♥';
    removeButton.type = 'button';
    removeButton.hidden = false;
    removeButton.dataset.spHeart = '';
    removeButton.dataset.productId = key;
    removeButton.dataset.productUrl = product.url;
    removeButton.setAttribute('aria-pressed', 'true');
    removeButton.setAttribute('aria-label', `${text.remove}: ${product.title}`);
    node.append(removeButton);
    const heading = element('h2');
    const titleLink = element('a', 'link', product.title);
    titleLink.href = product.url;
    heading.append(titleLink);
    node.append(heading);
    if (product.custom) {
      node.append(element('p', '', text.custom));
      const link = element('a', 'button', text.choose_options);
      link.href = product.url;
      node.append(link);
      return node;
    }
    const available = product.variants.filter(variant => variant.available);
    const price = element('p');
    const select = element('select');
    select.id = `sp-size-${key}`;
    select.setAttribute('aria-label', `${text.choose_size}: ${product.title}`);
    select.append(new Option(available.length ? text.choose_size : text.sold_out, ''));
    product.variants.forEach(variant => {
      const title = variant.title === 'Default Title' ? text.standard : variant.title;
      const option = new Option(`${title} — ${variant.price}${variant.available ? '' : ` · ${text.sold_out}`}`, String(variant.id));
      option.disabled = !variant.available;
      select.append(option);
    });
    select.value = selected.get(key) || '';
    const add = element('button', 'button', text.add_cart);
    add.type = 'button';
    const update = () => {
      selected.set(key, select.value);
      const variant = chosen(product);
      add.disabled = busy || !variant;
      price.textContent = variant?.price || text.choose_size;
      if (!busy && status && grid.children.length === read().length) status.textContent = text.choose_size;
    };
    select.disabled = !available.length || busy;
    select.addEventListener('change', update);
    add.addEventListener('click', () => addItems([key]));
    update();
    node.append(price, select, add);
    return node;
  }
  async function render() {
    if (!page) return;
    const run = ++generation;
    const saved = read();
    grid.replaceChildren();
    status.textContent = saved.length ? text.loading : text.empty;
    for (const item of saved) {
      if (run !== generation) return;
      try {
        const product = await load(item);
        if (run !== generation) return;
        grid.append(card(product));
      } catch {
        if (run !== generation) return;
        const failed = element('article', 'sp-wishlist-item sp-wishlist-item-error');
        failed.append(element('p', '', text.unavailable));
        const retry = element('button', 'button', text.retry);
        retry.type = 'button';
        retry.addEventListener('click', () => render());
        const discard = element('button', 'button button--secondary', text.remove);
        discard.type = 'button';
        discard.addEventListener('click', () => remove(item.id));
        failed.append(retry, discard);
        grid.append(failed);
      }
    }
    const incomplete = saved.some(item => !products.has(String(item.id)) || products.get(String(item.id)).custom || !chosen(products.get(String(item.id))));
    status.textContent = !saved.length ? text.empty : storageFailed ? text.storage_error : incomplete ? text.choose_size : text.ready;
    sync();
  }
  async function addItems(ids) {
    if (busy) return;
    busy = true;
    page?.querySelectorAll('button, select').forEach(control => { control.disabled = true; });
    status.textContent = text.adding;
    let submitted = false;
    try {
      const items = [];
      for (const id of ids) {
        const product = await load({ id, ...read().find(item => String(item.id) === id) }, true);
        const variant = chosen(product);
        if (product.custom || !variant) throw new Error(text.changed);
        items.push({ id: variant.id, quantity: 1 });
      }
      if (!items.length) throw new Error(text.choose_size);
      submitted = true;
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items })
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(text.cart_error);
      location.assign(`${root}cart`);
    } catch (error) {
      busy = false;
      await render();
      status.textContent = submitted ? text.cart_error : error.message;
      announce(status.textContent);
    }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sp-heart]');
    if (!button || busy) return;
    event.preventDefault();
    event.stopPropagation();
    const id = button.dataset.productId;
    const url = safeURL(button.dataset.productUrl);
    if (!/^\d+$/.test(id) || !url) return;
    const saved = read();
    if (saved.some(item => String(item.id) === id)) { remove(id); announce(text.removed); return; }
    if (saved.length >= 100) { announce(text.limit); return; }
    write([...saved, { id, url: url.pathname, paths: { [context]: url.pathname } }]);
    sync();
    announce(storageFailed ? text.storage_error : text.saved);
  }, true);
  page?.querySelector('[data-sp-share]')?.addEventListener('click', shareWishlist);
  page?.querySelector('[data-sp-share-close]')?.addEventListener('click', () => { page.querySelector('[data-sp-share-fallback]').hidden = true; page.querySelector('[data-sp-share]').focus(); });
  window.addEventListener('storage', event => { if (event.key === storageKey && sharedItems === null) { sync(); render(); } });
  document.addEventListener('shopify:section:load', sync);
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-sp-heart]') || node.querySelector?.('[data-sp-heart]'))))) sync();
  }).observe(document.body, { childList: true, subtree: true });
  sync();
  render();
})();

